import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { userNotificationList, MarkAsReads, fetchUserData, setUser } from "../../redux/actions";
import useFormat from "../../hooks/useFormat";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const SelfserviceMePage = () => {
    const { formatDate }                          = useFormat();
    const dispatch                                = useDispatch();
    const user_data                               = useSelector((state) => state?.user_data?.user_data) ?? {};
    const region                                  = useSelector((state) => state.region.region);
    const [notificationList, setNotificationList] = useState([]);
    let count = 1;

    const fetchNotificationData = useCallback( async () => {
        const data = await userNotificationList();
        
        if(data?.page?.data?.notifications) {
            setNotificationList(data?.page?.data?.notifications);
        }        
    }, []);

    useEffect( () => {
        fetchNotificationData();
    }, [fetchNotificationData]);

    const MarkAsRead = async (notification_id) => {

        let company_id = user_data?.company?.id;
        try {
            const data = await MarkAsReads(notification_id, region, company_id);
            
            if(data) {
                const user = await fetchUserData();
                if(user) {
                    await fetchNotificationData();                     
                    dispatch(setUser(user));    
                    toast.success(data);                
                }
            }
        } catch (e) {
            console.log(e);
            return;
        }
    };

    return(
        <>
            <section className="hot-deals pt-20">
                <div className="container container-lg ">
                    <div className="section-heading">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-8">
                            <h2 className="mb-0 text-blue">                                
                                &nbsp; <b>MY </b>NOTIFICATIONS
                            </h2>
                        </div>
                    </div>
                    <div className="row gy-4">
                        <div className="col-sm-9 font-md">
                            <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                                <div className="py-xl-4">
                                    <div className="d-flex flex-column gap-3">
                                        {notificationList.length === 0 && (
                                            <h5>No data found.</h5>
                                        )}
                                        {notificationList.length > 0 && (
                                            <div className='p-20 bg-color-one'>
                                                {notificationList.map(notification => (
                                                    <>
                                                        {notification.read_status === "read" && (                        
                                                            <div className="mt-20 p-20 bg-secondary-subtle text-black rounded-12">
                                                                <div className="row d-flex justify-content-between align-items-center">
                                                                    <div className="col-md-1 d-flex justify-content-center">
                                                                        <span className="rounded-10 bg-bit-lighter-blue px-10 py-5 fw-bold text-white">
                                                                            {count++}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <span>
                                                                            {notification?.message ?? ''}
                                                                            <span className='ml-5 fw-bold text-black'> - </span>
                                                                            <span className='ml-5 fw-bold text-black'>{ formatDate(notification?.created_at) ?? ''}</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2 d-flex justify-content-end">
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {notification.read_status === "unread" && (                        
                                                            <div className="mt-20 p-20 bg-white rounded-12">
                                                                <div className="row d-flex justify-content-between align-items-center">
                                                                    <div className="col-md-1 d-flex justify-content-center">
                                                                        <span className="rounded-10 bg-bit-lighter-blue px-10 py-5 fw-bold text-white">
                                                                            {count++}
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <span>
                                                                            {notification?.message ?? ''}
                                                                            <span className='ml-5 fw-bold text-black'> - </span>
                                                                            <span className='ml-5 fw-bold text-black'>{ formatDate(notification?.created_at) ?? ''}</span>
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-md-2 d-flex justify-content-end">
                                                                        <span>
                                                                            <Link                                                                                
                                                                                onClick={e => MarkAsRead(notification.id)}
                                                                            >
                                                                                <div className="circular-check">
                                                                                    ✔
                                                                                </div>
                                                                            </Link>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                            </div>
                                        )}   
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SelfserviceMePage;
